// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XXwgK3eLtE2X4TDVwz2u{flex-direction:column;gap:40px;padding:37px 23px 0;display:flex}.nnM3tXcghAIC6aFSLIkv{flex-direction:column;gap:16px;display:flex}.oMEQmHN3LXgfTz6D6muo{background:var(--background-neutral-subtle);border-radius:6px;padding:16px}.NFAdnsZveecKXO4lRnkD,.CEBsGxgpU80i7cJKFNdW{grid-template-columns:142px auto;align-items:center;display:grid}.ojB5vs3y2sMVfVN8GxTh{align-items:center;min-height:32px;display:flex}.ojB5vs3y2sMVfVN8GxTh span{max-width:198px}.vVNirewrPiE0TDbrwUnE{color:var(--content-primary-tertiary)}.CEBsGxgpU80i7cJKFNdW{margin-top:4px}.SaDIMKZJ_IUDIp4O3Qbd{gap:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabContent": `XXwgK3eLtE2X4TDVwz2u`,
	"section": `nnM3tXcghAIC6aFSLIkv`,
	"questionBox": `oMEQmHN3LXgfTz6D6muo`,
	"grid": `NFAdnsZveecKXO4lRnkD`,
	"contactGrid": `CEBsGxgpU80i7cJKFNdW`,
	"valueWrap": `ojB5vs3y2sMVfVN8GxTh`,
	"label": `vVNirewrPiE0TDbrwUnE`,
	"contactsValue": `SaDIMKZJ_IUDIp4O3Qbd`
};
export default ___CSS_LOADER_EXPORT___;
